import ButtonGooglePay from './ButtonGooglePay'

export default ButtonGooglePay
